import { render, staticRenderFns } from "./MainView.vue?vue&type=template&id=d0868cc8&scoped=true&"
import script from "./MainView.vue?vue&type=script&lang=js&"
export * from "./MainView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0868cc8",
  null
  
)

export default component.exports